<template>
  <div>
    <el-dialog :title="'指派施工员'" :visible="visible" width="80%" top="5vh" @close="closeDialog"
      :close-on-click-modal="false" append-to-body :z-index="1000">
      <div class="container">
        <div class="order-info" v-if="orderInfo && orderInfo.id">
          <div class="order-info__bar">
            <div class="order-info__item">
              <span class="order-info__label">报单商家：</span>
              <span class="order-info__value order-info__value--strong">{{ orderInfo.shopName || '--' }}</span>
            </div>
            <div class="order-info__item">
              <span class="order-info__label">工地联系人：</span>
              <span class="order-info__value">{{ orderInfo.contactName || '--' }}</span>
            </div>
            <div class="order-info__item">
              <span class="order-info__label">联系电话：</span>
              <span class="order-info__value">{{ orderInfo.contactMobile || '--' }}</span>
            </div>
            <div class="order-info__item order-info__item--grow">
              <span class="order-info__label">施工地址：</span>
              <span class="order-info__value">{{ orderInfo.customAddress || '--' }}</span>
            </div>
            <el-button type="text" size="mini" class="order-info__toggle" @click="orderInfoExpanded = !orderInfoExpanded">
              {{ orderInfoExpanded ? '收起' : '更多信息' }}
              <i :class="orderInfoExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </el-button>
          </div>
          <div class="order-info__more" v-show="orderInfoExpanded">
            <div class="order-info__item">
              <span class="order-info__label">房屋类型：</span>
              <span class="order-info__value">{{ orderInfo.buildingType || '--' }}</span>
            </div>
            <div class="order-info__item">
              <span class="order-info__label">户型信息：</span>
              <span class="order-info__value">{{ orderInfo.houseType || '--' }}</span>
            </div>
            <div class="order-info__item">
              <span class="order-info__label">付款人：</span>
              <span class="order-info__value">{{ orderInfo.customName || '--' }}</span>
            </div>
            <div class="order-info__item">
              <span class="order-info__label">付款人电话：</span>
              <span class="order-info__value">{{ orderInfo.customMobile || '--' }}</span>
            </div>
            <div class="order-info__item">
              <span class="order-info__label">预约人类型：</span>
              <span class="order-info__value">{{ orderInfo.appointmentType || '--' }}</span>
            </div>
          </div>
        </div>
        <el-table :data="allStages" border size="small" style="width: 100%" v-loading="getAllStagesLoading"
          v-if="allStages.length > 0 || getAllStagesLoading">
          <el-table-column label="阶段" align="center" min-width="90">
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="收费类型" width="80" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.isShow == '1' ? 'warning' : 'info'">
                {{ scope.row.isShow == '1' ? '收费' : '不收费' }}
              </el-tag>
            </template>
          </el-table-column> -->
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="getStatusType(scope.row.status)">{{ getStatusLabel(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="初始计划" align="center" min-width="170">
            <template slot-scope="scope">
              {{ formatPlanRange(scope.row.initialPlanStart, scope.row.initialPlanEnd) }}
            </template>
          </el-table-column>
          <el-table-column label="调整计划" align="center" min-width="200">
            <template slot-scope="scope">
              <div>{{ formatPlanRange(scope.row.adjustedPlanStart, scope.row.adjustedPlanEnd) }}</div>
              <div v-if="getPlanDriftDays(scope.row) > 0" class="plan-drift">
                顺延 {{ getPlanDriftDays(scope.row) }} 天
              </div>
              <div v-if="scope.row.adjustReason" class="adjust-reason">
                原因：{{ scope.row.adjustReason }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="实际进场" align="center" width="130">
            <template slot-scope="scope">
              {{ formatActualTime(scope.row.actualStartTime) }}
            </template>
          </el-table-column>
          <el-table-column label="实际完成" align="center" width="130">
            <template slot-scope="scope">
              {{ formatActualTime(scope.row.actualEndTime) }}
            </template>
          </el-table-column>
          <el-table-column label="当前施工员" align="center" min-width="130">
            <template slot-scope="scope">
              {{ formatEngineerDisplay(scope.row) }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="单据状态" width="110" align="center">
            <template slot-scope="scope">
              <div>
                <el-tag size="mini" :type="scope.row.submitted ? 'success' : 'info'">
                  {{ scope.row.submitted ? '已提交' : '未提交' }}
                </el-tag>
              </div>
              <div class="delivery-info">提货单：{{ formatDeliveryStatus(scope.row) }}</div>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" align="center" width="290" fixed="right">
            <template slot-scope="scope">
              <div class="operation-buttons">
                <el-button type="primary" size="mini" icon="el-icon-edit" @click="handleAssignEngineer(scope.row)"
                  :disabled="isAssignDisabled(scope.row)" v-if="permission.JOINS_SALES_CLOUD_WF_ASSIGN_ENGINEER">
                  {{ scope.row.engineerId ? '改派' : '指派' }}
                </el-button>
                <el-button size="mini" icon="el-icon-date" @click="handleAdjustPlan(scope.row)"
                  v-if="permission.JOINS_SALES_CLOUD_WF_ADJUST_PLAN && scope.row.id">
                  调整计划
                </el-button>
                <el-dropdown trigger="click" v-if="hasMoreActions(scope.row)"
                  @command="(command) => handleStageCommand(command, scope.row)">
                  <el-button size="mini">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="reverse" icon="el-icon-refresh"
                      v-if="(scope.row.status == 'TO_BE_EVALUATED' || scope.row.status == 'COMPLETE') && permission.JOINS_SALES_CLOUD_WF_REVERSE_REVIEW">
                      反审核
                    </el-dropdown-item>
                    <el-dropdown-item command="delete" icon="el-icon-delete" :disabled="isDeleteDisabled(scope.row)"
                      v-if="permission.JOINS_SALES_CLOUD_WF_ADD_STAGE">
                      删除
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div v-if="scope.row.errorMessage" class="error-message">
                {{ scope.row.errorMessage }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="add-stage-section" v-if="allStages.length > 0">
          <el-button size="small" icon="el-icon-plus" class="add-stage-btn" @click="showAddStageDialog"
            v-if="permission.JOINS_SALES_CLOUD_WF_ADD_STAGE">
            新增阶段
          </el-button>
        </div>
        <div class="empty-state" v-if="allStages.length === 0 && !getAllStagesLoading">
          <div class="empty-placeholder">
            <i class="el-icon-info"></i>
            <p>暂无阶段数据</p>
          </div>
          <el-button type="text" size="small" @click="showAddStageDialog"
            v-if="permission.JOINS_SALES_CLOUD_WF_ADD_STAGE">
            <i class="el-icon-plus"></i> 新增阶段
          </el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" size="small" icon="el-icon-close">关闭</el-button>
      </span>
      <el-dialog :title="assignDialogTitle" :visible="assignDialogVisible" width="75%" top="8vh"
        @close="assignDialogVisible = false" :close-on-click-modal="false" append-to-body :z-index="2000">
        <el-form :model="assignForm" label-width="110px" class="assign-form">
          <el-form-item label="计划进场时间：">
            <el-date-picker v-model="assignForm.planStartDate" type="datetime" placeholder="请选择客户计划进场时间"
              value-format="timestamp" format="yyyy-MM-dd HH:mm" :picker-options="assignPickerOptions"
              style="width: 240px" @change="handleExpectedDateChange">
            </el-date-picker>
            <el-radio-group v-model="assignForm.planStartPeriod" size="small" class="period-group">
              <el-radio-button label="AM" :disabled="isAmDisabled">上午（AM）</el-radio-button>
              <el-radio-button label="PM">下午（PM）</el-radio-button>
            </el-radio-group>
            <span v-if="isAmDisabled" class="period-tip">
              <i class="el-icon-warning"></i>已过中午 12 点，今日仅可选下午进场
            </span>
          </el-form-item>
        </el-form>
        <div class="avg-order-summary"
          v-if="assignForm.planStartDate && ((avgOrderCount !== undefined && avgOrderCount !== null && avgOrderCount !== '') || (stageTotalOrders !== undefined && stageTotalOrders !== null && stageTotalOrders !== ''))">
          <div class="avg-order-summary__icon">
            <i class="el-icon-tickets"></i>
          </div>
          <div class="avg-order-summary__body">
            <div class="avg-order-summary__row">
              <div class="avg-order-summary__item" v-if="avgOrderCount !== undefined && avgOrderCount !== null && avgOrderCount !== ''">
                <div class="avg-order-summary__label">本月{{ currentStage ? currentStage.name : '当前阶段' }}人均单量</div>
                <div class="avg-order-summary__value">
                  <span class="avg-order-summary__num">{{ avgOrderCount }}</span>
                  <span class="avg-order-summary__unit">单 / 人</span>
                </div>
              </div>
              <div class="avg-order-summary__divider" v-if="avgOrderCount !== undefined && avgOrderCount !== null && avgOrderCount !== '' && stageTotalOrders !== undefined && stageTotalOrders !== null && stageTotalOrders !== ''"></div>
              <div class="avg-order-summary__item" v-if="stageTotalOrders !== undefined && stageTotalOrders !== null && stageTotalOrders !== ''">
                <div class="avg-order-summary__label">本月{{ currentStage ? currentStage.name : '当前阶段' }}派单总量</div>
                <div class="avg-order-summary__value">
                  <span class="avg-order-summary__num">{{ stageTotalOrders }}</span>
                  <span class="avg-order-summary__unit">单</span>
                </div>
              </div>
            </div>
          </div>
          <div class="avg-order-summary__desc">用于评估当前可派单工程师整体负载</div>
        </div>
        <div class="engineer-section">
          <div class="engineer-section__header">
            <span class="engineer-section__title"><i class="el-icon-user"></i>选择施工员</span>
            <template v-if="assignForm.planStartDate">
              <span class="engineer-filter__count">共 {{ engineerTotal }} 人</span>
              <div class="engineer-section__search">
                <el-input v-model="engineerFilterKeyword" placeholder="按姓名/手机号搜索" clearable size="small"
                  prefix-icon="el-icon-search" style="width: 220px" @keyup.enter.native="handleEngineerSearch"
                  @clear="handleEngineerSearch" />
                <el-button type="primary" size="small" icon="el-icon-search" @click="handleEngineerSearch"
                  :loading="assignSearchLoading">搜索</el-button>
              </div>
            </template>
          </div>
          <div v-if="!assignForm.planStartDate" class="engineer-tip">请先选择客户计划进场时间</div>
          <template v-else>
            <div class="selected-engineer" v-if="selectedEngineerInfo">
              <i class="el-icon-user-solid"></i>
              <span>已选施工员：</span>
              <strong>{{ selectedEngineerInfo.name }}</strong>
              <span class="selected-engineer__phone" v-if="selectedEngineerInfo.mobile">{{
                selectedEngineerInfo.mobile }}</span>
              <el-button type="text" size="mini" class="selected-engineer__clear"
                @click="clearSelectedEngineer">清除重选</el-button>
            </div>
            <el-table :data="availableEngineers" v-loading="assignSearchLoading" border size="mini" max-height="360"
              highlight-current-row @row-click="handleSelectEngineer" :row-class-name="engineerRowClassName"
              empty-text="该时间暂无符合条件的可派单工程师" class="engineer-table" style="width: 100%">
              <el-table-column width="50" align="center">
                <template slot-scope="scope">
                  <el-radio v-model="assignForm.engineerId" :label="scope.row.userId">
                    <span></span>
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column label="工程师" prop="engineerName" align="center" min-width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" size="small" class="engineer-name-link"
                    @click.stop="handleOpenWeekBoard(scope.row)">{{ scope.row.engineerName }}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="分组" prop="groupName" align="center" min-width="110"
                show-overflow-tooltip></el-table-column>
              <el-table-column label="接单区域" prop="allowedArea" align="center" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.allowedArea || '--' }}</template>
              </el-table-column>
              <el-table-column label="钉钉排班" prop="dingTalkScheduleStatus" align="center" width="90"></el-table-column>
              <el-table-column label="当月本阶段订单数" prop="stageOrderCount" align="center" width="110"></el-table-column>
              <el-table-column label="总订单数" prop="orderCount" align="center" width="90"></el-table-column>
              <el-table-column label="预估状态" prop="constructionStatus" align="center" width="90"></el-table-column>
              <!-- <el-table-column label="当前接单" prop="orderType" align="center" width="90"></el-table-column> -->

              <el-table-column label="上单预计完成时间" prop="estimatedCompletionTime" align="center" width="150">
                <template slot-scope="scope">{{ formatEstimatedCompletionTime(scope.row.estimatedCompletionTime)
                }}</template>
              </el-table-column>
              <el-table-column label="周看板" align="center" width="80" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" icon="el-icon-date"
                    @click.stop="handleOpenWeekBoard(scope.row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="engineer-pagination" v-if="engineerTotal > engineerPageSize">
              <el-pagination background layout="prev, pager, next" :total="engineerTotal"
                :page-size="engineerPageSize" :current-page="engineerPage"
                @current-change="handleEngineerPageChange" />
            </div>
          </template>
        </div>
        <div class="assign-form-error" v-if="assignForm.errorMessage">
          <i class="el-icon-warning-outline"></i>{{ assignForm.errorMessage }}
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="assignDialogVisible = false" size="small" icon="el-icon-close">取消</el-button>
          <el-button type="primary" size="small" icon="el-icon-check" @click="confirmAssign" :loading="assignLoading"
            :disabled="!assignForm.engineerId"
            v-if="permission.JOINS_SALES_CLOUD_WF_ASSIGN_ENGINEER">确认指派</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="'新增阶段'" :visible="addStageDialogVisible" width="40%" @close="addStageDialogVisible = false"
        :close-on-click-modal="false" append-to-body :z-index="2000">
        <el-form :model="addStageForm" label-width="80px">
          <el-form-item label="选阶段：" :error="addStageForm.errorMessage">
            <el-select v-model="addStageForm.stageId" placeholder="请选择阶段" :loading="availableStagesLoading"
              :popper-append-to-body="false" style="width: 100%">
              <el-option v-for="stage in availableStages" :key="stage.id" :label="stage.name" :value="stage.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addStageDialogVisible = false" size="small" icon="el-icon-close">取消</el-button>
          <el-button type="primary" size="small" icon="el-icon-check" @click="confirmAddStage"
            :loading="addStageLoading" v-if="permission.JOINS_SALES_CLOUD_WF_ADD_STAGE">确认添加</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="'绑定经营主体'" :visible="businessEntityDialogVisible" width="40%"
        @close="businessEntityDialogVisible = false" :close-on-click-modal="false" append-to-body :z-index="3000">
        <el-form :model="businessEntityForm" label-width="180px">
          <el-form-item label="经营主体：">
            <el-select v-model="businessEntityForm.businessEntityId" placeholder="请选择经营主体" filterable remote
              reserve-keyword default-first-option :loading="businessEntityLoading"
              :remote-method="handleBusinessEntityRemoteSearch" :popper-append-to-body="false" style="width: 100%">
              <el-option v-for="entity in businessEntityList" :key="entity.id" :label="entity.entityName"
                :value="entity.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="businessEntityDialogVisible = false" size="small" icon="el-icon-close">取消</el-button>
          <el-button type="primary" size="small" icon="el-icon-check"
            @click="confirmBusinessEntityBinding">确认绑定</el-button>
        </span>
      </el-dialog>
      <!-- 调整阶段计划 / 补录入场·实际完成（文档 §Part 2） -->
      <el-dialog :title="'调整阶段计划'" :visible="adjustDialogVisible" width="50%" @close="adjustDialogVisible = false"
        :close-on-click-modal="false" append-to-body :z-index="4000">
        <el-form :model="adjustForm" label-width="120px" v-loading="adjustLoading">
          <el-form-item label="阶段：">
            <span>{{ adjustForm.stageName }}</span>
          </el-form-item>
          <div class="section-divider"><span>调整计划</span></div>
          <el-form-item label="调整计划：" :error="adjustForm.errorMessage">
            <el-date-picker v-model="adjustForm.adjustedPlanStart" type="datetime" placeholder="请选择调整计划时间"
              value-format="timestamp" format="yyyy-MM-dd HH:mm" :picker-options="adjustEndPickerOptions"
              style="width: 240px" />
          </el-form-item>
          <el-form-item label="调整原因：" :error="adjustForm.errorMessage">
            <el-input v-model="adjustForm.adjustReason" type="textarea" :rows="3"
              placeholder="请输入调整原因" maxlength="500" show-word-limit />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="adjustDialogVisible = false" size="small" icon="el-icon-close">取消</el-button>
          <el-button type="primary" size="small" icon="el-icon-check" @click="confirmAdjust" :loading="adjustLoading"
            v-if="permission.JOINS_SALES_CLOUD_WF_ADJUST_PLAN">确认调整</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <!-- 工程师个人周看板弹窗 -->
    <engineer-week-board ref="weekBoard"></engineer-week-board>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { updateWaterProofStage, getPhaseList, getWaterProofStageInfo, delPhaseWaterProofStage, addPhaseWaterProofStage, getAvailableEngineers, adjustStagePlan } from "@/api/work/waterProof/merchants";
import { reverseReviewWaterProof } from "@/api/work/waterProof/merchants";
import { getBusinessEntityList, addShopEntityBind } from '@/api/salesCloud/businessEntity/businessEntity';
import { DIC } from "@/const/dic";
import engineerWeekBoard from "./engineerWeekBoard.vue";
export default {
  name: "assignEngineerStage",
  components: { engineerWeekBoard },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    stages: {
      type: Array,
      default: () => [],
    },
    orderId: {
      type: [String, Number],
      required: true,
    },
    rootDepartId: {
      type: [String, Number],
      required: true,
    },
    shopId: {
      type: [String, Number, null],
      default: null,
    },
    shopName: {
      type: String,
      required: true,
    },
    contactMobile: {
      type: String,
      required: true,
    },
    customAddress: {
      type: String,
      required: true,
    },
    orderInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      allStages: [],
      availableStages: [],
      assignDialogVisible: false,
      addStageDialogVisible: false,
      businessEntityDialogVisible: false,
      adjustDialogVisible: false,
      currentStage: null,
      assignForm: {
        engineerId: null,
        planStartDate: null,
        planStartPeriod: 'AM',
        errorMessage: '',
      },
      // 计划进场时间：禁选今天之前的日期
      assignPickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date().setHours(0, 0, 0, 0);
        },
      },
      addStageForm: {
        stageId: null,
        errorMessage: '',
      },
      businessEntityForm: {
        businessEntityId: '',
      },
      businessEntityList: [],
      businessEntityLoading: false,
      currentShopId: null,
      currentShopName: '',
      currentShopMobile: '',
      currentCustomAddress: '',
      availableEngineers: [],
      // 施工员纯前端筛选关键字（姓名/手机号）
      engineerFilterKeyword: '',
      // 可派单工程师列表分页（文档：keyword/page/pageSize）
      engineerPage: 1,
      engineerPageSize: 10,
      engineerTotal: 0,
      // 月均订单数（文档：avgOrderCount，全局统计值）
      avgOrderCount: undefined,
      // 阶段当月总单数（与 avgOrderCount 平级返回，用于展示该阶段本月累计单数）
      stageTotalOrders: undefined,
      assignSearchLoading: false,
      assignLoading: false,
      adjustLoading: false,
      adjustForm: {
        stageId: '',
        orderId: '',
        stageName: '',
        adjustedPlanStart: null,
        adjustReason: '',
        errorMessage: '',
      },
      // 调整计划：完成时间禁选早于开始时间
      adjustEndPickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < new Date().setHours(0, 0, 0, 0);
        },
      },
      availableStagesLoading: false,
      addStageLoading: false,
      confirmLoading: false,
      getAllStagesLoading: false,
      // 报单信息折叠：默认只展示关键一行，点击"更多信息"展开
      orderInfoExpanded: false,
      // 已选施工员快照（翻页后当前页找不到该行时仍可展示）
      selectedEngineerInfo: null,
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    // 弹窗标题直接体现动作与阶段，省去表单里的"阶段"只读行
    assignDialogTitle() {
      const action = this.currentStage && this.currentStage.engineerId ? '改派施工员' : '指派施工员';
      const stageName = this.currentStage && this.currentStage.name ? `（${this.currentStage.name}）` : '';
      return action + stageName;
    },
    // 当前时间已过中午 12 点且期望进场日为今天（或尚未选择）时，上午槽不可选
    isAmDisabled() {
      const now = new Date();
      if (now.getHours() < 12) return false;
      if (!this.assignForm.planStartDate) return true;
      const sel = new Date(this.assignForm.planStartDate);
      return sel.toDateString() === now.toDateString();
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initData();
      }
    },
  },
  methods: {
    async initData() {
      await this.getAllStages();
      this.getAvailableStages();
    },
    async getAllStages() {
      this.getAllStagesLoading = true;
      try {
        const res = await getWaterProofStageInfo(this.orderId);
        if (res.code === "200") {
          const stagesData = JSON.parse(res.data) || [];
          console.log(stagesData)
          this.allStages = stagesData.map(stage => ({
            ...stage,
            id: stage.goodsId,
            name: stage.goodsName,
            status: stage.orderStatus,
            isShow: String(stage.isShow),
            engineerId: stage.engineerId,
            engineerName: stage.engineerName,
            delivered: stage.delivered,
            submitted: stage.submitted,
            errorMessage: '',
            isNewlyAdded: false,
          }));
        } else if (res.code == "24022061") {
          this.$message.warning(res.message || '报单商家经营主体不存在，请设置经营主体！');
          this.closeDialog();
          this.$emit('bindBusinessEntity');
          return;
        } else {
          this.$message.error(res.message || '获取阶段详情失败');
          this.allStages = [];
        }
      } catch (error) {
        this.$message.error('获取阶段详情失败');
        this.allStages = [];
      } finally {
        this.getAllStagesLoading = false;
      }
    },
    async getAvailableStages() {
      this.availableStagesLoading = true;
      try {
        const res = await getPhaseList(this.rootDepartId);
        if (res.code == "200") {
          const allConfiguredStages = JSON.parse(res.data) || [];
          this.availableStages = this.buildAvailableStages(allConfiguredStages);
        } else {
          this.$message.error(res.message || '获取阶段配置列表失败');
          this.availableStages = this.getMockAvailableStages();
        }
      } catch (error) {
        this.$message.error('获取阶段配置列表失败');
      } finally {
        this.availableStagesLoading = false;
      }
    },
    normalizeStageId(id) {
      return String(id);
    },
    buildAvailableStages(allConfiguredStages = []) {
      const existingStageIds = new Set(this.allStages.map(stage => this.normalizeStageId(stage.id)));
      const seenIds = new Set();
      const uniqueStages = [];
      allConfiguredStages.forEach((stage) => {
        const stageId = this.normalizeStageId(stage.id);
        if (!seenIds.has(stageId) && !existingStageIds.has(stageId)) {
          seenIds.add(stageId);
          uniqueStages.push(stage);
        }
      });
      return uniqueStages;
    },
    handleExpectedDateChange() {
      this.assignForm.engineerId = '';
      this.assignForm.errorMessage = '';
      this.availableEngineers = [];
      this.selectedEngineerInfo = null;
      this.engineerFilterKeyword = '';
      this.engineerPage = 1;
      if (this.assignForm.planStartDate) {
        // 精确到分：秒归零
        const d = new Date(this.assignForm.planStartDate);
        d.setSeconds(0, 0);
        let ts = d.getTime();
        // 不允许选择已过去的时间，自动调整为当前时间
        if (ts < Date.now()) {
          const now = new Date();
          now.setSeconds(0, 0);
          ts = now.getTime();
          this.$message.warning('不能选择已过去的时间，已自动调整为当前时间');
        }
        this.assignForm.planStartDate = ts;
        this.applyPeriodRestriction();
        this.loadAvailableEngineers();
      }
    },
    // 智能时间槽控制：上午槽不可选时强制切到下午
    applyPeriodRestriction() {
      if (this.isAmDisabled && this.assignForm.planStartPeriod === 'AM') {
        this.assignForm.planStartPeriod = 'PM';
      }
    },
    loadAvailableEngineers() {
      if (!this.assignForm.planStartDate) {
        return;
      }
      // 服务区域编码兜底 510100（文档示例市级编码）
      const serviceAreaCode = (this.orderInfo && this.orderInfo.areaCode) || '510100';
      // 阶段详情 goodsId 放入 body（文档：可派单工程师列表 §入参 goodsId）
      const data = {
        rootDepartId: this.rootDepartId,
        type: 'WATERPROOF_PROJECT',
        planStartDate: this.assignForm.planStartDate,
        serviceAreaCode: serviceAreaCode || '510100',
        keyword: this.engineerFilterKeyword || '',
        page: this.engineerPage || 1,
        pageSize: this.engineerPageSize || 10,
      };
      if (this.currentStage && this.currentStage.id) {
        data.goodsId = this.currentStage.id;
      }
      this.assignSearchLoading = true;
      getAvailableEngineers(data).then((res) => {
        if (res.code == "200") {
          const result = typeof res.data === 'string' ? (JSON.parse(res.data) || {}) : (res.data || {});
          this.availableEngineers = result.rows || [];
          // 月均订单数（全局统计值，与 rows 平级）
          this.avgOrderCount = result.avgOrderCount;
          // 阶段当月总单数（与 rows 平级返回）
          this.stageTotalOrders = result.stageTotalOrders;
          this.engineerTotal = result.total !== undefined ? result.total : (result.rows || []).length;
        } else {
          this.availableEngineers = [];
          this.avgOrderCount = undefined;
          this.stageTotalOrders = undefined;
          this.$message.error(res.message || '获取可用工程师失败');
        }
      }).catch(() => {
        this.availableEngineers = [];
        this.avgOrderCount = undefined;
        this.stageTotalOrders = undefined;
      }).finally(() => {
        this.assignSearchLoading = false;
      });
    },
    handleSelectEngineer(row) {
      this.assignForm.engineerId = row.userId;
      this.selectedEngineerInfo = {
        name: row.engineerName,
        mobile: row.engineerMobile,
      };
      this.assignForm.errorMessage = '';
    },
    clearSelectedEngineer() {
      this.assignForm.engineerId = '';
      this.selectedEngineerInfo = null;
    },
    engineerRowClassName({ row }) {
      return row.userId === this.assignForm.engineerId ? 'engineer-row--selected' : '';
    },
    // 操作列"更多"下拉：反审核 / 删除
    hasMoreActions(row) {
      const canReverse = (row.status == 'TO_BE_EVALUATED' || row.status == 'COMPLETE') && this.permission.JOINS_SALES_CLOUD_WF_REVERSE_REVIEW;
      const canDelete = !!this.permission.JOINS_SALES_CLOUD_WF_ADD_STAGE;
      return canReverse || canDelete;
    },
    handleStageCommand(command, row) {
      if (command === 'reverse') {
        this.handleReverseReview(row);
      } else if (command === 'delete') {
        this.handleDeleteStage(row);
      }
    },
    handleOpenWeekBoard(row) {
      console.log(row)
      this.$refs.weekBoard.open({
        engineerUserId: row.userId,
        engineerName: row.engineerName,
      });
    },
    // 关键字搜索（服务端 keyword，文档 §可派单工程师列表）
    handleEngineerSearch() {
      this.engineerPage = 1;
      this.loadAvailableEngineers();
    },
    handleEngineerPageChange(page) {
      this.engineerPage = page;
      this.loadAvailableEngineers();
    },
    handleAssignEngineer(stage) {
      this.currentStage = stage;
      // 计划进场时间默认当前时间（秒归零，不会早于当前）
      const now = new Date();
      now.setSeconds(0, 0);
      this.assignForm = {
        engineerId: '',
        planStartDate: now.getTime(),
        planStartPeriod: stage.planStartPeriod || 'AM',
        errorMessage: '',
      };
      this.applyPeriodRestriction();
      this.availableEngineers = [];
      this.selectedEngineerInfo = null;
      this.engineerFilterKeyword = '';
      this.engineerPage = 1;
      this.assignDialogVisible = true;
      this.loadAvailableEngineers();
    },
    confirmAssign() {
      if (!this.assignForm.planStartDate) {
        this.assignForm.errorMessage = '请选择客户计划进场时间';
        return;
      }
      if (!this.assignForm.planStartPeriod) {
        this.assignForm.errorMessage = '请选择进场时间槽';
        return;
      }
      if (!this.assignForm.engineerId) {
        this.assignForm.errorMessage = '请选择施工员';
        return;
      }
      this.assignLoading = true;
      const data = {
        projectType: "WATERPROOF_PROJECT",
        declarationId: this.orderId,
        goodsId: this.currentStage.id,
        engineerId: this.assignForm.engineerId,
        planStartDate: this.assignForm.planStartDate,
        planStartPeriod: this.assignForm.planStartPeriod,
      };
      updateWaterProofStage(data).then((res) => {
        if (res.code == "200") {
          this.$message.success('指派成功');
          const stageIndex = this.allStages.findIndex(s => s.id === this.currentStage.id);
          if (stageIndex !== -1) {
            const selectedEngineer = this.availableEngineers.find(e => e.userId === this.assignForm.engineerId);
            this.$set(this.allStages, stageIndex, {
              ...this.allStages[stageIndex],
              engineerId: this.assignForm.engineerId,
              engineerName: selectedEngineer ? selectedEngineer.engineerName : (this.selectedEngineerInfo ? this.selectedEngineerInfo.name : null),
              engineerPhone: selectedEngineer ? selectedEngineer.engineerMobile : (this.selectedEngineerInfo ? this.selectedEngineerInfo.mobile : null),
              status: 'IN_SERVICE',
              errorMessage: '',
            });
          }
          this.assignDialogVisible = false;
          this.$emit('refresh');
        } else if (res.code == "24022061") {
          this.$message.warning(res.message || '报单商家经营主体不存在，请设置经营主体！');
          this.openBusinessEntityDialog(this.shopId, this.shopName, this.contactMobile, this.customAddress);
        } else {
          this.$message.error(res.message || '指派失败');
        }
      }).finally(() => {
        this.assignLoading = false;
      });
    },
    // 打开调整阶段计划弹窗（文档 §Part 2）
    handleAdjustPlan(stage) {
      this.adjustForm = {
        stageId: stage.id,
        orderId: stage.orderId,
        stageName: stage.name,
        adjustedPlanStart: stage.adjustedPlanStart || null,
        adjustReason: '',
        errorMessage: '',
      };
      this.adjustDialogVisible = true;
    },
    // 确认调整阶段计划 / 补录实际时间（文档 §Part 2）
    confirmAdjust() {
      this.adjustForm.errorMessage = '';
      if (!this.adjustForm.adjustedPlanStart) {
        this.adjustForm.errorMessage = '请选择调整计划时间';
        return;
      }
      if (!this.adjustForm.adjustReason || !this.adjustForm.adjustReason.trim()) {
        this.adjustForm.errorMessage = '请输入调整原因';
        return;
      }
      this.adjustLoading = true;
      const data = {
        orderId: this.adjustForm.orderId,
        adjustedPlanStart: this.adjustForm.adjustedPlanStart,
        adjustReason: this.adjustForm.adjustReason.trim(),
      };
      adjustStagePlan(data).then((res) => {
        if (res.code == "200") {
          this.$message.success('调整阶段计划成功');
          this.adjustDialogVisible = false;
          // 刷新最外层指派施工员弹窗的阶段数据，确保看到更新后的调整计划
          this.initData();
          this.$emit('refresh');
        } else {
          this.adjustForm.errorMessage = res.message || '调整阶段计划失败';
        }
      }).finally(() => {
        this.adjustLoading = false;
      });
    },
    handleReverseReview(stage) {
      this.$confirm('是否确认反审核该阶段?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        reverseReviewWaterProof(stage.orderId).then((res) => {
          if (res.code == '200') {
            this.$message.success('反审核成功');
            this.initData();
            this.$emit('refresh');
          } else {
            this.$message.error(res.message || '反审核失败');
          }
        });
      }).catch(() => { });
    },
    handleDeleteStage(stage) {
      if (this.isDeleteDisabled(stage)) {
        this.$message.warning('当前阶段不可删除');
        return;
      }
      this.$prompt('请输入删除该阶段的原因', '删除阶段', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (val) => {
          if (!val || !val.trim()) {
            return '删除原因不能为空';
          }
          return true;
        },
      }).then(({ value }) => {
        const reason = value.trim();
        this.$confirm(`确定要删除该阶段的指派吗？\n删除原因：${reason}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delPhaseWaterProofStage(stage.orderId, reason).then((res) => {
            if (res.code == "200") {
              this.$message.success('删除成功');
              this.initData();
            } else {
              this.$message.error(res.message || '删除失败');
            }
          });
        }).catch(() => {
        });
      }).catch(() => {
      });
    },
    async showAddStageDialog() {
      this.addStageForm = {
        stageId: null,
        errorMessage: '',
      };
      await this.getAvailableStages();
      this.addStageDialogVisible = true;
    },
    confirmAddStage() {
      if (!this.addStageForm.stageId) {
        this.addStageForm.errorMessage = '请选择阶段';
        return;
      }
      this.addStageLoading = true;
      const selectedStage = this.availableStages.find(
        s => this.normalizeStageId(s.id) === this.normalizeStageId(this.addStageForm.stageId)
      );
      if (!selectedStage) {
        this.addStageForm.errorMessage = '阶段数据未准备好，请重试';
        return;
      }
      const data = {
        declarationId: this.orderId,
        goodsId: selectedStage.id,
      };
      addPhaseWaterProofStage(data).then((res) => {
        if (res.code == "200") {
          this.$message.success('新增阶段成功');
          this.initData();
          this.addStageDialogVisible = false;
          this.$emit('refresh');
        } else {
          this.$message.error(res.message || '新增阶段失败');
        }
      }).finally(() => {
        this.addStageLoading = false;
      });
    },
    isSubmittedOrWrittenOff(stage) {
      const isSubmitted = stage.submitted === true;
      const isWrittenOff = stage.delivered === true;
      return isSubmitted || isWrittenOff;
    },
    isAssignDisabled(stage) {
      return this.isSubmittedOrWrittenOff(stage);
    },
    isDeleteDisabled(stage) {
      return this.isSubmittedOrWrittenOff(stage);
    },
    getStatusType(status) {
      const map = {
        'WAIT_FOR_ASSIGN': 'info',
        'WAIT_ACCEPT': 'info',
        'IN_SERVICE': 'warning',
        'TO_BE_CONFIRMED': '',
        'TO_BE_THE_FINAL': '',
        'TO_BE_EVALUATED': '',
        'COMPLETE': 'success',
        'CANCELLED': 'danger',
      };
      return map[status] !== undefined ? map[status] : 'info';
    },
    getStatusLabel(status) {
      const statusItem = DIC.PRE_FILTER_STATUS.find(item => item.value === status);
      return statusItem ? statusItem.label : status;
    },
    formatEngineerDisplay(row) {
      const name = row.engineerName || '';
      if (name && /\([\d\-\+\s]+\)/.test(name)) {
        return name;
      }
      return name + ' ' + (row.engineerPhone ? '(' + row.engineerPhone + ')' : '未指派');
    },
    // 半天槽时间：计划字段落在当日 00:00（上午）或 12:00（下午），展示为 "MM-dd 上午/下午"
    formatSlotTime(ts) {
      if (ts == null) return '--';
      const d = new Date(Number(ts));
      const pad = (n) => (n < 10 ? '0' + n : String(n));
      const period = d.getHours() < 12 ? '上午' : '下午';
      return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${period}`;
    },
    // 计划区间：start ~ end（半天槽口径），计划链未生成时显示"未排期"
    formatPlanRange(start, end) {
      if (start == null && end == null) return '未排期';
      return `${this.formatSlotTime(start)} ~ ${this.formatSlotTime(end)}`;
    },
    // 实际打卡时刻：yyyy-MM-dd HH:mm，null = 未进场/未退场
    formatActualTime(ts) {
      if (ts == null) return '--';
      const d = new Date(Number(ts));
      const pad = (n) => (n < 10 ? '0' + n : String(n));
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    // 计划飘移：adjustedPlanEnd 晚于 initialPlanEnd 时显示顺延天数（可能带 0.5）
    getPlanDriftDays(row) {
      if (row.adjustedPlanEnd == null || row.initialPlanEnd == null) return 0;
      if (row.adjustedPlanEnd <= row.initialPlanEnd) return 0;
      return (row.adjustedPlanEnd - row.initialPlanEnd) / (24 * 3600 * 1000);
    },
    // 提货单状态 + 核销标识
    formatDeliveryStatus(row) {
      if (!row.deliveryStatus && !row.delivered) return '--';
      const statusItem = DIC.DELIVERY_ORDER_STATUS.find(item => item.value === row.deliveryStatus);
      const statusLabel = statusItem ? statusItem.label : (row.deliveryStatus || '');
      const deliveredLabel = row.delivered ? '已核销' : '未核销';
      return statusLabel ? `${statusLabel} / ${deliveredLabel}` : deliveredLabel;
    },
    // 预计完成时间：后端返回毫秒时间戳时转为可读日期，非时间戳字符串原样展示
    formatEstimatedCompletionTime(val) {
      if (val == null || val === '') return '--';
      const num = Number(val);
      if (!isNaN(num) && num > 0) {
        return this.formatActualTime(num);
      }
      return val;
    },
    closeDialog() {
      this.$emit('update:visible', false);
    },
    openBusinessEntityDialog(shopId, shopName, shopMobile, customAddress) {
      this.currentShopId = shopId;
      this.currentShopName = shopName;
      this.currentShopMobile = shopMobile;
      this.currentCustomAddress = customAddress;
      this.businessEntityDialogVisible = true;
      this.getBusinessEntityList();
    },
    getBusinessEntityList(entityName = '') {
      this.businessEntityLoading = true;
      const params = {
        page: '1',
        size: '100',
        entityName: entityName
      };
      getBusinessEntityList(params)
        .then(res => {
          const data = JSON.parse(res.data);
          this.businessEntityList = data.rows || [];
        })
        .finally(() => {
          this.businessEntityLoading = false;
        });
    },
    handleBusinessEntityRemoteSearch(query) {
      this.getBusinessEntityList(query);
    },
    confirmBusinessEntityBinding() {
      if (!this.businessEntityForm.businessEntityId) {
        this.$message.error('请选择要绑定的经营主体');
        return;
      }
      if (!this.currentShopId) {
        this.$message.error('商户信息有误，请重试');
        return;
      }
      const params = [{
        shopId: this.currentShopId,
        businessEntityId: this.businessEntityForm.businessEntityId,
        shopName: this.currentShopName,
        shopMobile: this.currentShopMobile
      }];
      addShopEntityBind(params)
        .then(res => {
          if (res.code == '200') {
            this.$message.success('绑定经营主体成功');
            this.businessEntityDialogVisible = false;
            this.businessEntityForm.businessEntityId = '';
            this.currentShopId = null;
            this.currentShopName = '';
            this.currentCustomAddress = '';
            this.currentShopMobile = '';
          } else {
            this.$message.error(res.message || '绑定经营主体失败');
          }
        });
    },
  },
};
</script>
<style scoped>
.container {
  max-height: calc(90vh - 170px);
  overflow-y: auto;
  padding-right: 10px;
}

.empty-state {
  padding: 40px 0;
  text-align: center;
}

.empty-state .empty-placeholder {
  color: #909399;
}

.empty-state .empty-placeholder i {
  font-size: 64px;
  display: block;
  margin-bottom: 16px;
}

.empty-state .empty-placeholder p {
  margin: 0;
  font-size: 14px;
}

.empty-state .el-button {
  margin-top: 20px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.container::-webkit-scrollbar {
  width: 8px;
}

.container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.el-table {
  margin-bottom: 20px;
}

.el-table th {
  background-color: #f5f7fa;
  font-weight: bold;
}

.operation-buttons {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.operation-buttons .el-button {
  margin: 0;
}

.operation-buttons .el-dropdown {
  margin: 0;
}

.add-stage-section {
  margin-top: 4px;
}

.add-stage-btn {
  width: 100%;
  border-style: dashed;
  color: #409eff;
  border-color: #b3d8ff;
  background: #ecf5ff;
}

.add-stage-btn:hover,
.add-stage-btn:focus {
  background: #d9ecff;
  border-color: #409eff;
  color: #409eff;
}

.el-form-item__error {
  position: absolute;
  top: 100%;
  left: 0;
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 4px;
}

.plan-drift {
  color: #e6a23c;
  font-size: 12px;
  line-height: 1.2;
  margin-top: 2px;
}
.adjust-reason {
  color: #909399;
  font-size: 12px;
  line-height: 1.2;
  margin-top: 2px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.delivery-info {
  color: #909399;
  font-size: 12px;
  line-height: 1.2;
  margin-top: 4px;
}

.order-info {
  margin-bottom: 14px;
  padding: 10px 14px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafbfd;
}

.order-info__bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 28px;
}

.order-info__more {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 28px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #e4e7ed;
}

.order-info__item {
  display: flex;
  align-items: baseline;
  font-size: 13px;
  color: #606266;
  min-width: 0;
}

.order-info__item--grow {
  flex: 1;
  min-width: 220px;
}

.order-info__label {
  color: #909399;
  flex-shrink: 0;
}

.order-info__value {
  word-break: break-all;
}

.order-info__value--strong {
  font-weight: 600;
  color: #303133;
}

.order-info__toggle {
  margin-left: auto;
  flex-shrink: 0;
}

.selected-engineer {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  padding: 6px 12px;
  background: #f0f9eb;
  border: 1px solid #c2e7b0;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}

.selected-engineer i {
  color: #67c23a;
}

.selected-engineer strong {
  color: #303133;
}

.selected-engineer__phone {
  color: #909399;
  font-size: 12px;
}

.selected-engineer__clear {
  margin-left: auto;
}

.period-group {
  margin-left: 16px;
}

::v-deep .engineer-row--selected td {
  background-color: #ecf5ff !important;
}

.engineer-tip {
  color: #909399;
  font-size: 13px;
}

.assign-form {
  margin-bottom: 2px;
}

.engineer-section {
  margin-top: 4px;
}

.engineer-section__header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.engineer-section__title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.engineer-section__title i {
  margin-right: 6px;
  color: #409eff;
}

.engineer-filter__count {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}

.engineer-section__search {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.engineer-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.assign-form-error {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  color: #f56c6c;
  font-size: 12px;
}

::v-deep .engineer-table .el-table__row {
  cursor: pointer;
}

.avg-order-summary {
  display: flex;
  align-items: center;
  margin: 0 0 14px;
  padding: 14px 22px;
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f1ff 100%);
  border: 1px solid #d6e6ff;
  border-left: 4px solid #409eff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(64, 158, 255, 0.10);
}

.avg-order-summary__icon {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5aa7ff 0%, #409eff 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-right: 18px;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
}

.avg-order-summary__body {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.avg-order-summary__row {
  display: flex;
  align-items: stretch;
}

.avg-order-summary__item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 26px;
}

.avg-order-summary__item:first-child {
  padding-left: 0;
}

.avg-order-summary__divider {
  width: 1px;
  align-self: center;
  height: 38px;
  background: linear-gradient(to bottom, transparent, #c5dcff 30%, #c5dcff 70%, transparent);
}

.avg-order-summary__label {
  font-size: 12px;
  color: #606266;
  line-height: 1.4;
  white-space: nowrap;
}

.avg-order-summary__value {
  display: flex;
  align-items: baseline;
  margin-top: 4px;
}

.avg-order-summary__num {
  font-size: 26px;
  font-weight: 600;
  color: #303133;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.avg-order-summary__unit {
  margin-left: 4px;
  font-size: 12px;
  color: #909399;
}

.avg-order-summary__desc {
  margin-left: auto;
  font-size: 12px;
  color: #909399;
  padding-left: 16px;
}

.period-tip {
  margin-left: 12px;
  color: #e6a23c;
  font-size: 12px;
}

.period-tip i {
  margin-right: 4px;
}

.engineer-name-link {
  padding: 0;
}

.engineer-name-link:hover {
  text-decoration: underline;
}

.section-divider {
  display: flex;
  align-items: center;
  margin: 6px 0 18px;
  color: #606266;
  font-size: 13px;
  font-weight: 600;
}

.section-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #ebeef5;
  margin-left: 12px;
}
</style>